// extracted by mini-css-extract-plugin
module.exports = {"loader":"_2rwIZ","loadAnimation":"_2mFUf"};